import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Reset scroll to the top of the page on every route change.
 *
 * We use useLayoutEffect (synchronous, pre-paint) so the new page never
 * flashes a mid-scroll position. If the incoming URL has a `#hash`, we let
 * the browser handle the anchor jump (used by Home in-page nav).
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if (hash) return;
    // Force both scroll axes to 0 across all major browsers.
    window.scrollTo(0, 0);
    if (document.documentElement) document.documentElement.scrollTop = 0;
    if (document.body) document.body.scrollTop = 0;
  }, [pathname, hash]);

  return null;
}
